import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Input,
  Text,
  Textarea,
  useMediaQuery,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useForm, Controller } from "react-hook-form";
import { useMutation } from '@apollo/client';
import { CONTACT_US } from '../Graphql/Mutations';

export default function Contact() {
  const [contactUsQuery, contactUs] = useMutation(CONTACT_US);
  const toast = useToast();
  const { control, handleSubmit, formState: { errors }, trigger } = useForm();
  const fontLabelStyle = {
    color: "#1F508C",
    fontSize: "16px",
    fontWeight: "bold"
  };
  const inputStyle = {
    background: "#FAFAFA"
  }
  const onSubmit = async (data) => {
    trigger().then(async (isValid) => {
      if (isValid) {
        try {
          console.log("Data of contact us form", data);
          const contactUsInput = {
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            subject: data.subject,
            message: data.message,
          };
          console.log(contactUsInput);
          await contactUsQuery({ variables: contactUsInput });
        }
        catch (error) {
          console.log("Error in submitting contact us form: ", error);
        }
      }
    });
  };
  const [isxl] = useMediaQuery("(min-width: 2000px)");
  const [is2xl] = useMediaQuery("(min-width: 2200px)");
  const [is3xl] = useMediaQuery("(min-width: 2536px)");
  const [is4xl] = useMediaQuery("(min-width: 2836px)");
  const [is5xl] = useMediaQuery("(min-width: 2936px)");
  const [is6xl] = useMediaQuery("(min-width: 5400px)");
  const [is7xl] = useMediaQuery("(min-width: 6500px)");
  const userDashboardMainBox = {
    px: is7xl ? "35vw" : is6xl ? "31.6vw" : is5xl ? "23.7vw" : is4xl ? "15vw" : is3xl ? "12vw" : is2xl ? "10.2vw" : isxl ? "5.7vw" : "0px",
  };
  useEffect(() => {

    console.log("error:", contactUs.error)
    console.log("loading:", contactUs.loading)
    console.log("data:", contactUs.data)

    if (contactUs.data != undefined) {
      if (contactUs?.data?.sendContactUsEmail?.success) {
        toast({
          title: 'Succeed',
          description: 'Submitted Successfully',
          status: 'success',
          duration: 4000,
          isClosable: true,
          position: "bottom-left"
        });
        // localStorage.setItem("userAddress", data.getAddress)
        // navigate('/dashboard');
      }
      else {
        toast({
          title: 'Error',
          description: contactUs?.data?.sendContactUsEmail?.message,
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: "bottom-left"
        });
      }
    }
    if (contactUs.error != undefined) {
      toast({
        title: 'error',
        description: contactUs.error.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: "bottom-left"
      });
    }
  }, [contactUs.data, contactUs.loading, contactUs.error])
  return (
    <Box>
      <Box bg={"linear-gradient(300deg, #1899C7 36%, #1F508B 100%)"} textAlign="center" padding={"60px 0px"}>
        <Text color={"white"} fontSize={"34px"}>Contact Us</Text>
        <Text fontSize={"22px"} color={"#fff"} mt={"8px"} p={{ base: "0px 10px 0px 10px", lg: "0px" }}>Send us a message and we will get back to you as soon as possible.</Text>
      </Box>
      <Box padding={"50px 0px 60px 0px"} {...userDashboardMainBox}>
        <Grid templateColumns="repeat(12, 1fr)" gap={4}>
          <GridItem colSpan={{ base: 12, lg: 6 }} mb={{ base: "10px", lg: "0px" }} paddingLeft={{ base: "20%", lg: "40%" }} paddingRight={{ base: "20%", lg: "0px" }} mx={{ base: "auto", lg: "unset" }}>
            <Box>
              <Text fontSize="33px" color="#1F508B">Meet Our Team</Text>
              <Text marginBottom={"31.5px"} as="p" lineHeight={"1.7rem"} fontSize="14px" color="#1F508B">The team comes with over 45 years combined experience in Capital Markets and Technology Leadership. See how we can help you increase your investment.</Text>
              <Text fontSize="20px" color="#1F508B">Asset Tokenization CRE will soon be expanding to major markets across the USA.</Text>
            </Box>
            <Box mt={"8px"} position="relative" display="inline-block">
              <Text color="#1F508B" fontSize={"24px"}>Email</Text>
              <Box
                position="absolute"
                bottom="-5px"
                left="0"
                right="0"
                borderBottom="1px solid #1F508B"
              />
            </Box>
            <Box mt={"20px"}>
              <Text cursor={"pointer"} color="#1F508B">admin@gmail.com</Text>
            </Box>
            <Box mt={"8px"} position="relative" display="inline-block">
              <Text color="#1F508B" fontSize={"24px"}>Location</Text>
              <Box
                position="absolute"
                bottom="-5px"
                left="0"
                right="0"
                borderBottom="1px solid #1F508B"
              />
            </Box>
            <Box mt={"20px"}>
              <Text cursor={"pointer"} color="#1F508B">Suite 313, 833 Bourbon Court,
                Mountain View, 94041 CA</Text>
            </Box>
          </GridItem>
          <GridItem colSpan={{ base: 12, lg: 6 }} mt={{ base: "20px", lg: "0px" }} paddingLeft={{ base: "20%", lg: "20px" }} paddingRight={{ base: "20%", lg: "40%" }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl isRequired>
                <FormLabel {...fontLabelStyle}>Name</FormLabel>
                <Flex>
                  <Controller
                    name="firstName"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Input {...field} {...inputStyle} type="text" placeholder="Enter First name" mr={2} />
                    )}
                  />
                  <Controller
                    name="lastName"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Input {...field} {...inputStyle} type="text" placeholder="Enter Last name" />
                    )}
                  />
                </Flex>
              </FormControl>
              <Flex mt={4}>
                <FormControl mr={4} isRequired>
                  <FormLabel {...fontLabelStyle}>Email</FormLabel>
                  <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Input {...field} {...inputStyle} type="email" placeholder="Enter your email" />
                    )}
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel {...fontLabelStyle}>Subject</FormLabel>
                  <Controller
                    name="subject"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Input {...field} {...inputStyle} type="text" placeholder="Enter the subject" />
                    )}
                  />
                </FormControl>
              </Flex>
              <FormControl mt={4} isRequired>
                <FormLabel {...fontLabelStyle}>Message</FormLabel>
                <Controller
                  name="message"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <Textarea {...field} {...inputStyle} placeholder="Enter your message" height={"150px"} />
                  )}
                />
              </FormControl>
              <Button type="submit" isLoading={contactUs.loading} mt={4} bg={"#002B5B"} _hover={{ bg: "#002B5B" }} color={"white"} width="100%">
                Submit
              </Button>
            </form>
          </GridItem>
        </Grid>
      </Box>
    </Box>
  );
}